var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tabs-content"},_vm._l((_vm.tabsList),function(item,index){return _c('div',{key:index,staticClass:"tabs-content-item",class:{ active: _vm.tabsActive == item.value },on:{"click":function($event){return _vm.tabsClick(item.value)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }